
import { Link } from 'react-router-dom';

import './CapCode.scss';


function CapCode() {


  const carcapcode = [
    { position: '1-2', description: 'Manufacturer' },
    { position: '3-4', description: 'Model Name' },
    { position: '5-6', description: 'Engine Size (cc/100, rounding to nearest full number)' },
    { position: '7-9', description: 'Trim level' },
    { position: '10', description: 'Number of Doors' },
    { position: '11', description: 'Body Type (see table below)' },
    { position: '12', description: 'Fuel Type (see table below)' },
    { position: '13', description: 'Fuel Delivery (see table below)' },
    { position: '14', description: 'Transmission ("A" or "M")' },
    { position: '15', description: 'Drive Train (see table below)' },
    { position: '16', description: 'Blank' },
    { position: '17', description: 'Sequence Number Used as a model sequence number' },
    { position: '18-20', description: 'Blank' },
  ];

  const carletters = [
    { column1: 'A – Hardtop', column2: '	P- Petrol', column3: '	I – Injection', column4: '	4 – Four Wheel Drive' },
    { column1: 'B – Cabriolet', column2: '	D – Diesel', column3: '	T – Turbo', column4: '	S – Four Wheel Steering' },
    { column1: 'C – Coupe', column2: '	B – Petrol/LPG', column3: '	S – Supercharged', column4: '	R – Rear Wheel Drive' },
    { column1: 'E – Estate', column2: '	G – Petrol/CNG', column3: '	Blank – Normally Aspired', column4: '	F – Front Wheel Drive' },
    { column1: 'F – Fastback', column2: '	E – Electric', column3: '', column4: '' },
    { column1: 'H – Hatchback', column2: '	H – Petrol/Electric Hybrid', column3: '', column4: '' },
    { column1: 'O – Soft-Top', column2: '	F – Petrol/Bio-Ethanol (E85)', column3: '', column4: '' },
    { column1: 'Q – Speedster', column2: '	Y – Diesel/Electric Hybrid', column3: '', column4: '' },
    { column1: 'R – Roadster', column2: '	X – Petrol/Plugin Electric Hybrid', column3: '', column4: '' },
    { column1: 'S – Saloon', column2: '	Z – Diesel/Plugin Electric Hybrid', column3: '', column4: '' },
    { column1: 'T – Tourer', column2: '	C – Hydrogen Fuel Cell', column3: '', column4: '' },
    { column1: 'V – Convertible', column2: '', column3: '', column4: '' },
    { column1: 'W – Station Wagon', column2: '', column3: '', column4: '' },
  ];


  const bikecapcode = [
    { position: '1-2', description: '	Manufacturer HO - HONDA, YA - Yamaha' },
    { position: '3-4', description: '	Model CB, FZ -etc' },
    { position: '5-7', description: '	Engine Size 060 - 600cc, 134 - 1340cc' },
    { position: '8-9', description: '	Year Code (Generation) R1 K2 etc.' },
    { position: '10-11', description: '	Style Code' },
    { position: '12', description: '	Gears 4,5,6,or 7' },
    { position: '13', description: '	Drive C - Chain, B - Belt, S - Shaft, A - Automatic' },
    { position: '14-17', description: '	Unused' },
    { position: '18', description: '	Intro Month A - January .. L - December' },
    { position: '19', description: '	Intro Year 0 - 1987, 1 - 1988, 5 - 1992, A - 1997, D - 2000' },
    { position: '20', description: '	Vehicle Type "B"' },
  ];

  const bikeletters = [
    { column1: 'A – Hardtop', column2: '	P- Petrol' },
    { column1: 'AT – ATV', column2: '	B - Road' },
    { column1: 'BU – Buggy', column2: '	O - Off Road' },
    { column1: 'CB  - Combination', column2: '	I – Imported' },
    { column1: 'CO - Commuter', column2: '	PWC - Jetski' },
    { column1: 'CU – Custom', column2: '' },
    { column1: 'DU – Dual', column2: '' },
    { column1: 'DI – Direct Import', column2: '' },
    { column1: 'EN – Enduro', column2: '' },
    { column1: 'JS – Jetski', column2: '' },
    { column1: 'MI – Mini', column2: '' },
    { column1: 'MO – Moped', column2: '' },
    { column1: 'MX – Motor Cross', column2: '' },
    { column1: 'QU – Quad', column2: '' },
    { column1: 'RO – Roadster', column2: '' },
    { column1: 'SC – Scooter', column2: '' },
    { column1: 'SM – Super Motard', column2: '' },
    { column1: 'SP – Sports', column2: '' },
    { column1: 'SR – Sidecar', column2: '' },
    { column1: 'TD – Traditional', column2: '' },
    { column1: 'TI – Trials', column2: '' },
    { column1: 'TO – Tourer', column2: '' },
    { column1: 'RD – Trail', column2: '' },
    { column1: 'TW – Three Wheeler', column2: '' }
  ];


  const lcvcapcode = [
    { position: '1-2', description: '	Manufacturer' },
    { position: '3-4', description: '	Model' },
    { position: '5-6', description: '	Engine Size (cc/100, round to nearest full number)' },
    { position: '7-10', description: '	Trim Level' },
    { position: '11', description: '	Body Type' },
    { position: '12', description: '	Fuel Type' },
    { position: '13', description: '	Fuel Delivery' },
    { position: '14', description: '	Transmission ("A" or "M")' },
    { position: '15', description: '	Drive Train' },
    { position: '16', description: '	Unused' },
    { position: '17', description: '	Sequence' },
    { position: '18', description: '	Version Month (A=Jan B-Feb etc)' },
    { position: '19', description: '	Version Year (0=1986 1=1987 etc A=1996 B=1997 etc)' },
    { position: '20', description: '	Vehicle Type (L= Light Commercial)' },

  ];

  const lcvletters = [
    { column1: 'A – Hardtop', column2: '	P- Petrol', column3: '	I – Injection' },
    { column1: '0 – High Roof Platform', column2: '	P- Petrol', column3: '	I – Injection' },
    { column1: '1 – Double Chassis Cab', column2: '	D – Diesel', column3: '	T – Turbo' },
    { column1: '2 – Extended Frame double Cab Chassis', column2: '	B – Petrol/LPG', column3: '	Blank – Normal Aspiration' },
    { column1: '3 – High Cube', column2: '	G – Petrol/CNG', column3: '' },
    { column1: '4 – Platform Cab', column2: '	E – Electric', column3: '' },
    { column1: '5 – Dropside Tipper', column2: '	H – Petrol/Electric Hybrid', column3: '' },
    { column1: '6 – Medium Roof Van', column2: '	F – Petrol/Bio-Ethanol (E85)', column3: '' },
    { column1: '7 – Double Cab Pick-up', column2: '	Y – Diesel/Electric Hybrid', column3: '' },
    { column1: '8 – Double Cab Luton', column2: '	X – Petrol/Plugin Electric Hybrid', column3: '' },
    { column1: '9 – Extra High Roof', column2: '	Z – Diesel/Plugin Electric Hybrid', column3: '' },
    { column1: 'A – Hard Top', column2: '', column3: '' },
    { column1: 'B – Chassis Cab', column2: '', column3: '' },
    { column1: 'C – Curtainside', column2: '', column3: '' },
    { column1: 'D – Dropside', column2: '', column3: '' },
    { column1: 'E – Estate', column2: '', column3: '' },
    { column1: 'F – Fridge Van', column2: '', column3: '' },
    { column1: 'G – Long Cube', column2: '', column3: '' },
    { column1: 'H – High Volume/High Roof Van', column2: '', column3: '' },
    { column1: 'I – Medium Roof Window Van', column2: '', column3: '' },
    { column1: 'J – Double Cab Dropside', column2: '', column3: '' },
    { column1: 'K – Combi Van', column2: '', column3: '' },
    { column1: 'L – Luton', column2: '', column3: '' },
    { column1: 'M – Double Cab Tipper', column2: '', column3: '' },
    { column1: 'N – High Roof Window Van', column2: '', column3: '' },
    { column1: 'O – Soft Top', column2: '', column3: '' },
    { column1: 'P – Pick-up', column2: '', column3: '' },
    { column1: 'Q – Ex/Frame Dropside', column2: '', column3: '' },
    { column1: 'R – Ex/Frame Double Cab Dropside', column2: '', column3: '' },
    { column1: 'S – Box Van', column2: '', column3: '' },
    { column1: 'T – Tipper', column2: '', column3: '' },
    { column1: 'U – High Roof Minibus', column2: '', column3: '' },
    { column1: 'V – Van', column2: '', column3: '' },
    { column1: 'W – Window Van', column2: '', column3: '' },
    { column1: 'X – Fridge Box', column2: '', column3: '' },
    { column1: 'Y – Standard Roof Van', column2: '', column3: '' },
    { column1: 'Z – Crew Bus', column2: '', column3: '' },
  ];


  const hgvcapcode = [
    { position: '1-2', description: '	Manufacturer' },

    { position: '3-7', description: '	Model' },
    { position: '8-11', description: '	Chassis Layout' },
    { position: '12', description: '	Chassis Height' },
    { position: '13', description: '	Suspension Type' },
    { position: '14', description: '	Driveline type' },
    { position: '15', description: '	Cab type' },
    { position: '16-17', description: '	GVW/GCW' },
    { position: '18', description: '	Body Type' },
    { position: '19', description: '	Sequence Number' },
    { position: '20', description: '	Chassis Type' },
  ];


  const hgvletters = [
    { column1: '42SD 4x2 single drive', column2: 'S – Standard', column3: 'S – Steel', column4: 'S – Single Reduction – manual transmission', column5: 'D - Day', column6: '3501-3999 A', column7: 'No Trailer A', column8: 'N - No body (either chassis-cab or tractor)', column9: 'C – Car Transporter' },
    { column1: '42SL 4x2 single drive low weight', column2: 'H – High', column3: 'R – Rear air', column4: 'A – Single Reduction – Automatic Transmission', column5: 'R – Rest/extended day', column6: '4000-4499 B', column7: '18000-19999 B', column8: 'P - Platform', column9: 'D – Distribution' },
    { column1: '44AS 4x4 4 wheel drive single rear wheels', column2: 'L – Low', column3: 'F – Full air', column4: 'H - Hub Reduction – Manual Transmission', column5: 'F – High day', column6: '4500-4999 C', column7: '20000-21999 C', column8: 'D - Dropside', column9: 'F – Fire Appliance' },
    { column1: '44AT 4x4 4 wheel drive twin rear wheels', column2: 'X - Extra Low', column3: 'B – Rear Rubber', column4: 'R – Hub Reduction – Auto Transmission', column5: 'N- Narrow Sleeper', column6: '5000-5999 D', column7: '22000-23999 D', column8: 'B - Boxvan', column9: 'K – Tipper' },
    { column1: '62FS 6x2 rigid, non-lift tag axle with single rear wheels', column2: '', column3: '', column4: '', column5: 'G – Narrow/High Sleeper', column6: '6000-7499 E', column7: '24000-25999 E', column8: 'C -Curtainside', column9: 'S – Sweeper' },
    { column1: '62MD 6x2 mid-lift', column2: '', column3: '', column4: '', column5: 'V – Wide Low Sleeper', column6: '7500-7999 F', column7: '26000-27999 F', column8: 'F - Fridge box', column9: 'T – Tractor Unit' },
    { column1: '62MT 6x2 mid-lift/twin steer', column2: '', column3: '', column4: '', column5: 'W – Wide Sleeper', column6: '8000-9999 G', column7: '28000-29999 G', column8: 'S - Skiploader', column9: 'X – Mixer' },
    { column1: '62ML 6x2 mid-lift low weight', column2: '', column3: '', column4: '', column5: 'H – Wide/High Sleeper', column6: '10000-10999 H', column7: '30000-31999 H', column8: 'H - Hookloader', column9: 'M - Municipal' },
    { column1: '62RL 6x2 rear lift – single rear wheels', column2: '', column3: '', column4: '', column5: 'X - Extra High Sleeper', column6: '11000-11999 I', column7: '32000-33999 I', column8: 'T - Tipper', column9: '' },
    { column1: '62RT 6x2 rear lift – twin rear wheels', column2: '', column3: '', column4: '', column5: 'L – Luxury High Sleeper', column6: '12000-12999 J', column7: '34000-35999 J', column8: 'V - Panel van low roof', column9: '' },
    { column1: '62RS 6x2 rear steer', column2: '', column3: '', column4: '', column5: 'E – Low Entry', column6: '13000-13999 K', column7: '36000-37999 K', column8: 'M - Panel van high roof', column9: '' },
    { column1: '62TS 6x2 twin steer', column2: '', column3: '', column4: '', column5: 'C – Crew Cab', column6: '14000-14999 L', column7: '38000-39999 L', column8: 'X - Panel van extra high roof', column9: '' },
    { column1: '64DD 6x4 double drive', column2: '', column3: '', column4: '', column5: 'Z – Low Entry Crew Cab', column6: '15000-15999 M', column7: '40000-41999 M', column8: 'W -Window van', column9: '' },
    { column1: '66AD 6x6 6 wheel drive', column2: '', column3: '', column4: '', column5: '', column6: '16000-17999 N', column7: '44000 O', column8: 'Y - Window van high roof', column9: '' },
    { column1: '82RL 8x2 rear lift – single rear wheels', column2: '', column3: '', column4: '', column5: '', column6: '18000-19999 O', column7: '1-7999 P', column8: 'I - Panel van access high roof', column9: '' },
    { column1: '82RT 8x2 rear lift – twin rear wheels', column2: '', column3: '', column4: '', column5: '', column6: '20000-21999 P', column7: '8000-9999 Q', column8: 'J - Panel van access extra high roof', column9: '' },
    { column1: '82RS 8x2 rear steer', column2: '', column3: '', column4: '', column5: '', column6: '22000-23999 Q', column7: '10000-11999 R', column8: '', column9: '' },
    { column1: '84RS 8x4 rear steer', column2: '', column3: '', column4: '', column5: '', column6: '24000-25999 R', column7: '12000-13999 S', column8: '', column9: '' },
    { column1: '84DD 8x4 double drive', column2: '', column3: '', column4: '', column5: '', column6: '26000-27999 S', column7: '14000-15999 T', column8: '', column9: '' },
    { column1: '86DD 8x6 double drive', column2: '', column3: '', column4: '', column5: '', column6: '28000-31999 T', column7: '16000-17999 U', column8: '', column9: '' },
    { column1: '88AD 8x8 8 wheel drive', column2: '', column3: '', column4: '', column5: '', column6: '32000-35999 U', column7: '42000-43999 N', column8: '', column9: '' },
    { column1: '', column2: '', column3: '', column4: '', column5: '', column6: '36000-37999 V', column7: '', column8: '', column9: '' },
    { column1: '', column2: '', column3: '', column4: '', column5: '', column6: '38000-40000 W', column7: '', column8: '', column9: '' }
  ];

  return (
    <div className='capcode-container'>
      <h1 className='header-text'>CAPcode</h1>

      <p className='standard-text'>Every vehicle is uniquely identified by a ID number which is a sequential integer value and a 20 character alpha-numeric code. The construction of the code for each vehicle type is presented below</p>


      <h2>Car<br />
      </h2>

      <table id = "carcapcode">
        <thead>
          <tr>
            <th>Position</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {carcapcode.map((item, index) => (
            <tr key={index}>
              <td>{item.position}</td>
              <td>{item.description}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="table-spacer"></div>

      <table id = "carletters">
        <thead>
          <tr>
            <th>Body Types</th>
            <th>Fuel Types</th>
            <th>Fuel Delivery</th>
            <th>Drive Train</th>
          </tr>
        </thead>
        <tbody>
          {carletters.map((item, index) => (
            <tr key={index}>
              <td>{item.column1}</td>
              <td>{item.column2}</td>
              <td>{item.column3}</td>
              <td>{item.column4}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <h2 className="section-spacer">Bike<br />
      </h2>

      <table id = "bikecapcode">
        <thead>
          <tr>
            <th>Position</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {bikecapcode.map((item, index) => (
            <tr key={index}>
              <td>{item.position}</td>
              <td>{item.description}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="table-spacer"></div>

      <table id = "bikeletters">
        <thead>
          <tr>
            <th>Style Codes</th>
            <th>Vehicle Types</th>
          </tr>
        </thead>
        <tbody>
          {bikeletters.map((item, index) => (
            <tr key={index}>
              <td>{item.column1}</td>
              <td>{item.column2}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <h2 className="section-spacer">LCV<br />
      </h2>

      <table id = "lcvcapcode">
        <thead>
          <tr>
            <th>Position</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {lcvcapcode.map((item, index) => (
            <tr key={index}>
              <td>{item.position}</td>
              <td>{item.description}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="table-spacer"></div>
      
      <table id = "lcvletters">
        <thead>
          <tr>
            <th>Body Types</th>
            <th>Fuel Types</th>
            <th>Fuel Delivery</th>
          </tr>
        </thead>
        <tbody>
          {lcvletters.map((item, index) => (
            <tr key={index}>
              <td>{item.column1}</td>
              <td>{item.column2}</td>
              <td>{item.column3}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <h2 className="section-spacer">HGV<br />
      </h2>

      <table id = "hgvcapcode">
        <thead>
          <tr>
            <th>Position</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {hgvcapcode.map((item, index) => (
            <tr key={index}>
              <td>{item.position}</td>
              <td>{item.description}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="table-spacer"></div>
      
      <table id = "hgvletters">
        <thead>
          <tr>
            <th>Chassis Layout</th>
            <th>Chassis Height</th>
            <th>Suspension Type</th>
            <th>Driveline Type</th>
            <th>Cab Type</th>
            <th>GVW</th>
            <th>GCW</th>
            <th>Body Type</th>
            <th>Chassis Type</th>
          </tr>
        </thead>
        <tbody>
          {hgvletters.map((item, index) => (
            <tr key={index}>
              <td>{item.column1}</td>
              <td>{item.column2}</td>
              <td>{item.column3}</td>
              <td>{item.column4}</td>
              <td>{item.column5}</td>
              <td>{item.column6}</td>
              <td>{item.column7}</td>
              <td>{item.column8}</td>
              <td>{item.column9}</td>
            </tr>
          ))}
        </tbody>
      </table>


      <div>
      </div>
    </div>
  );
};

export default CapCode
